// @flow

import React, { Component } from 'react';
import styler from 'react-styling';
import radium from 'radium';
import ToggleButton from 'react-toggle-button';
import { browserHistory } from 'react-router';

import LogoGray from '../../../img/symfoni_logo_gray.png';

function _createStyle(theme: string) {
  return styler `
    Container
      width: 100%
      position: fixed
      bottom: 0
      padding: 10px 30px
      background-color: ${theme === 'dark' ? '#0C1428' : '#ECECEC'}
    Logo
      float: left
      text-align: right
      width: 50%
      margin-top: -3px
    Image
      width: 100px
    Toggle
      float: left
      width: 50%
  `;
}
class MeetingRoomFooter extends Component {
  state: {
    value: string,
    theme: string,
  }={
    value: this.props.theme || 'dark',
    theme: this.props.theme || 'dark',
  }

  props: {
    theme: string,
    onToggle: Function,
  }

  _onToggle = () => {
    this.setState({
      value: this.state.value === 'light' ? this.state.value = 'dark' : this.state.value = 'light',
    });
    this.state.theme === 'light' ? this.state.theme = 'dark' : this.state.theme = 'light';
    browserHistory.push({
      pathname: '#/meetingrooms',
      search: `?theme=${this.state.theme}`,
    });
    this.props.onToggle(this.state.theme);
  }

  render() {
    const style = _createStyle(this.state.theme);
    const value = this.state.value === 'light';
    return (
      <div style={style.Container}>
        <div style={style.Toggle}>
          <ToggleButton
            value={value}
            onToggle={this._onToggle}
            inactiveLabel="Dark"
            activeLabel="Light"
            colors={{
              activeThumb: {
                base: '#497BEB',
              },
              inactiveThumb: {
                base: '#497BEB',
              },
              active: {
                base: '#BABABA',
                hover: '#D4D4D4',
              },
              inactive: {
                base: '#253966',
                hover: '#14264C',
              },
            }}
          />
        </div>
        <div style={style.Logo}>
          <img id="xc-sym-logo" src={LogoGray} alt="Symfoni Software" style={style.Image} />
        </div>
      </div>
    );
  }
}

export default radium(MeetingRoomFooter);



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingRoomFooter.js